<template>
  <div class="slider-verify-warp">
    <div  class="verify-refresh-handle">
      <div>完成拼图验证</div>
      <div class="slide-verify-refresh" @click="refresh">
        <van-icon name="replay" />
        <span class="slide-verify-refresh-text">换一张</span>
      </div>
    </div>
    <div
      id="slideVerify"
      class="slide-verify"
      :style="widthLable"
      onselectstart="return false;"
    >
      <canvas ref="canvas" :width="w" :height="h" />
      <canvas ref="block" class="slide-verify-block" :class="{'tran-animation2':tranAnimation}" :width="w" :height="h" />
    </div>
    <div
      class="slide-verify-slider"
      :style="sliderWidth"
      :class="{
        'container-active': containerActive,
        'container-success': containerSuccess,
        'container-fail': containerFail,
      }"
    >
      <div class="slide-verify-slider-mask" :class="{'tran-animation1':tranAnimation}" :style="{ width: sliderMaskWidth,'height':(sh - 12)+'px' }">
        <!-- slider -->
        <div
          class="slide-verify-slider-mask-item"
          :class="{'tran-animation2':tranAnimation}"
          :style="{ 'left': sliderLeft,'width':(sw - 12)+'px','height':(sh - 12)+'px' }"
          @mousedown="sliderDown"
          @touchstart="touchStartEvent"
          @touchmove="touchMoveEvent"
          @touchend="touchEndEvent"
        >
        </div>
      </div>
      <span class="slide-verify-slider-text">{{ sliderText }}</span>
    </div>
  </div>
</template>
<script>
import {
  Icon,
} from "vant";
function sum(x, y) {
  return x + y;
}

function square(x) {
  return x * x;
}
export default {
  name: "SlideVerify",
  components: {
     [Icon.name]: Icon,
  },
  props: {
    // block length
    l: {
      type: Number,
      default: 42,
    },
    // block radius
    r: {
      type: Number,
      default: 10,
    },
    // canvas width
    w: {
      // 背景图宽
      type: [Number, String],
      default: 300,
    },
    // canvas height
    h: {
      // 背景图高
      type: [Number, String],
      default: "150",
    },
    // canvas width
    sw: {
      // 小图宽
      type: [Number, String],
      default: 60,
    },
    // canvas height
    sh: {
      type: [Number, String],
      default: 60,
    },
    blocky: {
      // 小图初始的垂直距离
      type: Number,
      default: 20,
    },
    sliderText: {
      type: String,
      default: "向右滑动完成拼图",
    },
    imgUrl: {
      // 大图地址
      type: String,
      default: "",
    },
    miniImgUrl: {
      // 小图地址
      type: String,
      default: "",
    },
    fresh: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      containerActive: false, // container active class
      containerSuccess: false, // container success class
      containerFail: false, // container fail class
      tranAnimation:false,
      canvasCtx: null,
      blockCtx: null,
      block: null,
      canvasStr: null,
      L: this.l + this.r * 2 + 3, // block real lenght
      img: undefined,
      originX: undefined,
      originY: undefined,
      isMouseDown: false,
      trail: [],
      widthLable: "",
      sliderWidth: "",
      sliderLeft: 0, // block right offset
      sliderMaskWidth: 0, // mask width
      dialogVisible: false,
      infoText: "验证成功",
      showInfo: false
    };
  },
  watch: {
    fresh(val) {
      if (val) {
        this.init();
      }
    },
  },
  mounted() {
    // 随机生成数this.block_x =
    this.init();
    console.log(
      "device-width:",
      window.screen.width,
      "device-height",
      window.screen.height,
      "-webkit-device-pixel-ratio",
      window.devicePixelRatio
    );
  },
  methods: {
    init() {
      this.initDom();
      this.bindEvents();
      this.widthLable = "width:" + this.w + "px;" + "height:" + this.h + "px";
      this.sliderWidth = "width:" + Number(this.w) + "px;"+ "height:" + (this.sh - 12) + "px";;
    },
    initDom() {
      this.block = this.$refs.block;
      this.canvasStr = this.$refs.canvas;
      this.canvasCtx = this.canvasStr.getContext("2d");
      this.blockCtx = this.block.getContext("2d");
      this.initImg();
    },
    initImg() {
      var that = this;
      const img = document.createElement("img");
      img.onload = onload;
      img.onerror = () => {
        img.src = that.imgUrl;
      };
      img.src = that.imgUrl;
      img.onload = function() {
        that.canvasCtx.drawImage(img, 0, 0, that.w, that.h);
      };

      this.img = img;
      const img1 = document.createElement("img");
      var blockCtx = that.blockCtx;

      img1.onerror = () => {
        img1.src = that.miniImgUrl;
      };
      img1.src = that.miniImgUrl;
      img1.onload = function() {
      blockCtx.drawImage(img1, 0, that.blocky, that.sw, that.sh);
        
      };
    },
    //刷新
    refresh() {
      this.$emit("refresh");
    },
    sliderDown(event) {
      this.originX = event.clientX;
      this.originY = event.clientY;
      this.isMouseDown = true;
      this.tranAnimation = false;
    },
    touchStartEvent(e) {
      this.originX = e.changedTouches[0].pageX;
      this.originY = e.changedTouches[0].pageY;
      this.isMouseDown = true;
      this.tranAnimation = false;
    },
    bindEvents() {
      document.addEventListener("mousemove", (e) => {
        if (!this.isMouseDown) return false;
        const moveX = e.clientX - this.originX;
        const moveY = e.clientY - this.originY;
        if (moveX < 0 || moveX + (this.sw - 12) >= this.w) return false;
        this.sliderLeft = moveX + "px";
        const blockLeft = ((this.w - (this.sw-10)) / (this.w - (this.sw-10))) * moveX;
        this.block.style.left = blockLeft + "px";
        this.containerActive = true; // add active
        this.sliderMaskWidth = (moveX + 6) + "px";
        this.trail.push(moveY);
      });
      document.addEventListener("mouseup", (e) => {
        if (!this.isMouseDown) return false;
        this.isMouseDown = false;
        if (e.clientX === this.originX) return false;
        this.containerActive = false; // remove active
        this.verify();
      });
    },
    touchMoveEvent(e) {
      if (!this.isMouseDown) return false;
      const moveX = e.changedTouches[0].pageX - this.originX;
      const moveY = e.changedTouches[0].pageY - this.originY;
      if (moveX < 0 || moveX + (this.sw - 12) >= this.w) return false;
      this.sliderLeft = moveX + "px";
      const blockLeft = ((this.w - (this.sw-10)) / (this.w - (this.sw-10))) * moveX;
      this.block.style.left = blockLeft + "px";

      this.containerActive = true;
      this.sliderMaskWidth = (moveX+6) + "px";
      this.trail.push(moveY);
    },
    touchEndEvent(e) {
      if (!this.isMouseDown) return false;
      this.isMouseDown = false;
      if (e.changedTouches[0].pageX === this.originX) return false;
      this.containerActive = false;
      this.verify();
    },
    verify() {
      if(this.trail.length===0) return false;
      const arr = this.trail; // drag y move distance
      const average = arr.reduce(sum) / arr.length; // average
      const deviations = arr.map((x) => x - average); // deviation array
      const stddev = Math.sqrt(deviations.map(square).reduce(sum) / arr.length); // standard deviation
      const left = parseInt(this.block.style.left);
      this.$emit("verify", left, stddev);
    },
    reset(h) {
      this.containerActive = false;
      this.containerSuccess = false;
      this.containerFail = false;
      this.sliderLeft = 0;
      this.block.style.left = 0;
      this.sliderMaskWidth = 0;
      this.canvasCtx.clearRect(0, 0, this.w, this.h);
      this.blockCtx.clearRect(0, 0, this.w, this.h);
      this.showInfo = false;
      this.initImg();
    },
    handleFail() {
      this.containerActive = false;
      this.containerSuccess = false;
      this.showInfo = true;
      this.infoText = "验证失败";
      this.containerFail = true;
      this.tranAnimation = true;
      this.block.style.left = 0;
      this.sliderMaskWidth = 0;
      this.sliderLeft = 0;
      let cl1 = setTimeout(() => {
        this.containerFail = false;
        this.tranAnimation = false;
        this.refresh()//重新渲染图片
        clearTimeout(cl1)
      }, 600);
    },
    handleSuccess() {
      this.showInfo = true;
      this.infoText = "验证成功";
      this.containerSuccess = true;
    },
  },
};
</script>
<style scoped>
.slider-verify-warp {
  padding-top: 10px;
  padding-bottom: 20px;
  box-shadow: 0 0 5px 5px #eee;
}
.verify-refresh-handle {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 15px;
  padding: 0 12px;
}
.slide-verify {
  position: relative;
  width: 310px;
  border-radius: 5px;
  overflow: hidden;
  margin: 0 auto;
}

.slide-verify-block {
  position: absolute;
  left: 0;
  top: 0;
}

.slide-verify-refresh {
  display: flex;
  align-items: center;
  color: #0077ff;
  cursor: pointer;
}

.slide-verify-refresh-text {
  width: 50px;
  height: 34px;
  line-height: 34px;
  display: inline-block;
  font-size: 14px;
  text-align: right;
}

.slide-verify-refresh-icon {
  width: 30px;
  height: 34px;
  line-height: 34px;
  cursor: pointer;
  content: "换一张";
  font-size: 22px;
  text-align: center;
  font-weight: bold;
  background-size: 34px 471px;
}
.slide-verify-refresh-icon:hover {
  transform: rotate(360deg);
  transition: all 0.3s ease-in-out;
}

.slide-verify-slider {
  position: relative;
  text-align: center;
  /* width: 310px;
  height: 48px; */
  margin: 0 auto;
  line-height: 40px;
  margin-top: 15px;
  background: #f7f9fa;
  color: #45494c;
  border: 1px solid #e4e7eb;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
}

.slide-verify-slider-mask {
  position: absolute;
  left: 0;
  top: 0;
  /* height: 50px; */
  /* border: 0 solid #1991fa; */
  background: #d1e9fe;
}

.slide-verify-info {
  position: absolute;
  top: 170px;
  left: 0;
  height: 30px;
  width: 350px;
  color: #fff;
  text-align: center;
  line-height: 30px;
  background-color: #52ccba;
  opacity: 0;
}
.slide-verify-info.fail {
  background-color: #f57a7a;
}
.slide-verify-info.show {
  animation: hide 1s ease;
}
@keyframes hide {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 0.9;
  }
}
.slide-verify-slider-mask-item {
  position: absolute;
  top: 0;
  left: 0;
  /* width: 48px;
  height: 48px; */
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);
  cursor: pointer;
  background: url("./../assets/images/right-icon.png");
  background-repeat: no-repeat;
  background-color: #1991fa;
  background-size: 60% auto;
  background-position: center center;
  z-index: 100;
  border-radius: 6px;
}

.slide-verify-slider-mask-item:hover {
  /* height: 48px; */
  /* background: #1991fa; */
}


.container-active .slide-verify-slider-mask-item {
  height: 48px;
  top: -1px;
  border: 1px solid #1991fa;
}
.tran-animation1{
  -webkit-transition: width 0.4s 0.1s linear;
  -moz-transition: width 0.4s 0.1s linear;
  -ms-transition: width 0.4s 0.1s linear;
  -o-transition: width 0.4s 0.1s linear;
  transition: width 0.4s 0.1s linear;
}
.tran-animation2{
  -webkit-transition: left 0.4s 0.1s linear;
  -moz-transition: left 0.4s 0.1s linear;
  -ms-transition: left 0.4s 0.1s linear;
  -o-transition: left 0.4s 0.1s linear;
  transition: left 0.4s 0.1s linear;
}
.container-active .slide-verify-slider-mask {
  height: 48px;
  top: -1px;
  border-width: 1px;
  border: 1px solid #1991fa;
}

.container-success .slide-verify-slider-mask-item {
  height: 48px;
  top: -1px;
  border: 1px solid #52ccba;
  background: url("./../assets/images/success-icon.png");
  background-repeat: no-repeat;
  background-color: #52ccba ;
  background-size: 60% auto;
  background-position: center center;
  z-index: 100;
  border-radius: 6px;
}

.container-success .slide-verify-slider-mask {
  height: 48px;
  top: -1px;
  border: 1px solid #52ccba;
  background-color: #d2f4ef;
}


.container-fail .slide-verify-slider-mask-item {
  height: 48px;
  top: -1px;
  border: 1px solid #e2231a;
  background: url("./../assets/images/error-icon.png");
  background-repeat: no-repeat;
  background-color: #e2231a;
  background-size: 60% auto;
  background-position: center center;
  z-index: 100;
  border-radius: 6px;
}

.container-fail .slide-verify-slider-mask {
  height: 48px;
  border: 1px solid #f57a7a;
  background-color: #fce1e1;
}

.container-active .slide-verify-slider-text,
.container-success .slide-verify-slider-text,
.container-fail .slide-verify-slider-text {
  display: none;
}
@media only screen and (device-width: 1280px) and (device-height: 800px) and (-webkit-device-pixel-ratio: 2) {
.verify-refresh-handle{
    font-size: 12px;
}
}
</style>